module.exports = __webpack_public_path__ + "static/img/1_0015.5681a51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0015.jpg
// module id = K9jW
// module chunks = 0